import {Tooltip} from '@mui/material';
import {CustomTablePagination} from '..';
import Icons from '../../Assets';
import styles from './styles.module.scss';
import React from "react";

type HrCompaniesTableProps = {
    values: Array<{
        id: number;
        companyName: string;
        fein: string;
        contactName: string;
        phone: string;
        url: string;
    }>;
    pageCount: number;
    currentPage: number;
    noResultsPlaceholder: string;
    onRowClick: (id: number) => void;
    onGenerateLinkClick: (url: string) => void;
    onPageChange: (page: number) => void;
    onInfoClick: (id: number) => void;
};

const HrCompaniesTable: React.FC<HrCompaniesTableProps> = (
    {
        values,
        pageCount,
        currentPage,
        noResultsPlaceholder,
        onRowClick,
        onGenerateLinkClick,
        onPageChange,
        onInfoClick
    }) => {
    const pageChangeHandler = (selectedItem: { selected: number }) => {
        onPageChange(selectedItem.selected);
    };

    const isEmptyContainer = values.length === 0;

    return (
        <div className={styles.container}>
            <div className={styles.tableContainer}>
                {!isEmptyContainer && (
                    <table className={styles.table}>
                        <thead className={styles.tableHead}>
                        <tr className={styles.headerRow}>
                            <th className={styles.headerCell} align='left'>
                                Company name
                            </th>
                            <th
                                className={styles.headerCell}
                                align='center'
                            >
                                FEIN
                            </th>
                            <th
                                className={styles.headerCell}
                                align='center'
                            >
                                Contact name
                            </th>
                            <th
                                className={styles.headerCell}
                                align='center'
                            >
                                Phone
                            </th>
                            <th
                                className={styles.headerCell}
                                align='center'
                            >
                                Actions
                            </th>
                        </tr>
                        </thead>
                        <tbody className={styles.tableBody}>
                        {values.map((item) => {
                            return (
                                <tr
                                    key={item.fein + item.companyName}
                                    className={styles.tableRow}
                                    onClick={() => onRowClick(item.id)}
                                >
                                    <td
                                        className={styles.cell}
                                        align='left'
                                    >
                                        {item.companyName}
                                    </td>
                                    <td
                                        className={styles.cell}
                                        align='center'
                                    >
                                        {item.fein}
                                    </td>
                                    <td
                                        className={styles.cell}
                                        align='center'
                                    >
                                        {item.contactName}
                                    </td>
                                    <td
                                        className={styles.cell}
                                        align='center'
                                    >
                                        {item.phone}
                                    </td>
                                    <td
                                        className={styles.cell}
                                        align='center'
                                    >
                                        <div
                                            className={
                                                styles.actionsContainer
                                            }
                                        >
                                            <Tooltip title='Generate Link'>
                                                <Icons.CompanyTableLinkIcon
                                                    className={
                                                        styles.actionIcon
                                                    }
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onGenerateLinkClick(
                                                            item.url
                                                        );
                                                    }}
                                                />
                                            </Tooltip>

                                            <Tooltip title='View company'>
                                                <Icons.DetailInfoIcon
                                                    className={
                                                        styles.actionIcon
                                                    }
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onInfoClick(item.id);
                                                    }}
                                                />
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                )}
                {isEmptyContainer && (
                    <div className={styles.noResultsFound}>
                        {noResultsPlaceholder}
                    </div>
                )}
            </div>
            <CustomTablePagination
                onPageChange={pageChangeHandler}
                pageCount={pageCount}
                currentPage={currentPage}
            />
        </div>
    );
};

export default HrCompaniesTable;
